import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BsFacebook, BsLinkedin, BsInstagram } from 'react-icons/bs';

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <footer className="sa-footer">

        {/* ── Top: white bg, navy text ── */}
        <div className="sa-footer-top">
          <div className="sa-container">

            {/* Col 1 – Logo + address + social */}
            <div className="sa-footer-col">
              <Link to="/">
                <img
                  src="/images/Somayya-Academy-Logo-for-Website-Home.001.png"
                  alt="Somayya Academy"
                  onError={e => { e.currentTarget.src = '/images/Somayya_academy_transparent.png'; }}
                />
              </Link>
              <p style={{ marginTop: 10 }}>
                Somayya Academy,<br />
                S. No. 12/6, Parthsarthi,<br />
                Near City Pride, Kothrud,<br />
                Pune-411038.
              </p>
              {/* Social icons — small navy squares with white icons */}
              <div className="sa-footer-social">
                <a href="https://www.facebook.com/somayya.classes.9/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <BsFacebook aria-hidden="true" />
                </a>
                <a href="https://www.linkedin.com/in/somayya-classes/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <BsLinkedin aria-hidden="true" />
                </a>
                <a href="https://www.instagram.com/somayyaclasses147/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <BsInstagram aria-hidden="true" />
                </a>
              </div>
            </div>

            {/* Col 2 – Information: phone + email only */}
            <div className="sa-footer-col">
              <h3>Information</h3>
              <ul className="sa-footer-contact">
                <li>
                  <i className="fa fa-phone" />
                  <a href="tel:+919511840674">+91 9511840674</a>
                </li>
                <li>
                  <i className="fa fa-envelope-o" />
                  <a href="mailto:info@somayyaacademy.com">info@somayyaacademy.com</a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* ── Bottom: dark navy ── */}
        <div className="sa-footer-bottom">
          <div className="sa-container">
            <p>
              &copy; 2021 Somayya Academy All Rights Reserved. &nbsp; Developed By{' '}
              <a href="https://myelin.co.in" target="_blank" rel="noopener noreferrer">
                Prysom Systems
              </a>
            </p>
            <div className="sa-footer-policy">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-and-conditions">Terms And Conditions</Link>
              <Link to="/refundsandcancellation">Refund And Cancellation</Link>
            </div>
          </div>
        </div>

      </footer>

      {/* ── Scroll-to-top button — red circle with up arrow, bottom-right ── */}
      {showTop && (
        <button
          className="sa-scroll-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="fa fa-arrow-up" />
        </button>
      )}
    </>
  );
}
